/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "right",
  },
}));

const ChangeStatus = (props) => {
  const { handleClose, open, state, onSaveClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`Job# ${state.selectedOrder.jobId} `}</span>
          </Fragment>
        }
        content={
          <Fragment>
            <div>
              <span
                style={{
                  fontSize: 18,
                  color: "#1558a2",
                  fontWeight: 700,
                }}
              >
                {state.actionTypeFailedId == 11
                  ? "Are you sure, you want to send to QA ?"
                  : "Are you sure, you want to send to Printing ?"}
              </span>
            </div>
            <br />
            <div></div>
            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick(state.actionTypeFailedId)}
                disabled={state.onCancelItemStatusLoading}
                variant="contained"
                color="primary"
              >
                {state.onCancelItemStatusLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  "Yes"
                )}
              </Button>
              <Button
                disabled={state.onCancelItemStatusLoading}
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                No
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeStatus.propTypes = {
  handleClose: PropTypes.func,
  onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeStatus.defaultProps = {
  handleClose: (fn) => fn,
  onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeStatus;
